import React from "react";
import styled from "@emotion/styled";
import { image } from "../../theme";
import { LinkKakaoAccountText } from "@utils/lanugauge-settings/static-texts/TranslatedTexts";

const Container = styled.div(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "0 1rem",
  padding: "1.6rem",
  fontFamily: theme.fontFamily.primaryFont,
  fontWeight: 600,
  fontSize: "1.6rem",
  background: "#FEE100",
  borderRadius: "0.5rem",
  maxWidth: "27.4rem",
  width: "100%",
  cursor: "pointer",
}));

const KakaoLoginButton = ({ onClick }) => {
  return (
    <Container onClick={onClick}>
      <img src={image.kakaoActive.default} alt="kakao" width={30} />

      <p>
        <LinkKakaoAccountText />
      </p>
    </Container>
  );
};

export default KakaoLoginButton;
